<div id="stage" class="container d-flex flex-column">
    <div class="row">
        <div class="col-12 text-center">
            <img id="logoWithType" alt="Logo" src="assets/images/logoWithType.svg">
        </div>
    </div>

    <img *ngIf="slideStack.length" (click)="goBackward()" class="back" src="assets/images/backArrow.svg">

    <img *ngIf="calcPath!='pro'" (click)="onCloseCalculator()" class="close" src="assets/images/closeX.svg">

    <!-- SELF PROGRESS BAR -->
    <div *ngIf="showProgressBar" class="row">
        <div class="col-md-8 offset-md-2 col-sm-12">
            <div id="progressFrame">
                <div id="progressBar"></div>
                <div *ngFor="let stage of progressStages" class="progressCell" [ngClass]="{'active': stage == contentData[currentSlide].stage, 'done': progressStages.indexOf(stage) < progressStages.indexOf(contentData[currentSlide].stage) }">{{stage | titlecase}}</div>
            </div>
        </div>
    </div>

    <!-- CLIENT PROGRESS BAR-->
    <div *ngIf="contentData[currentSlide].mode == 'client' && calcPath == 'pro'" class="row my-3">
        <div class="col-12 col-md-8 offset-md-2">
            <div class="proNav justify-content-center">
                <!-- ['proDetails','proActivity','proDiet', 'proGoal', 'proResults'] -->
                <div class="slimButton">
                    <span class="checkSpan" *ngIf="proDetailsForm.valid" [ngClass]="{'invisible': !proDetailsForm.valid}">&#10003;</span>
                    <button (click)="goForward('proDetails')" [ngClass]="{'greenButton': true, 'lightGrayButton': currentSlide != 'proDetails'}">Details</button>
                </div>
                <div class="slimButton">
                    <span class="checkSpan" [ngClass]="{'invisible': !proGoalForm.valid}">&#10003;</span>
                    <button [disabled]="proDetailsForm.valid ? false : true" (click)="goForward('proGoal')" [ngClass]="{'greenButton': true, 'lightGrayButton': currentSlide != 'proGoal'}">Goal</button>
                </div>
                <div class="slimButton">
                    <span class="checkSpan" [ngClass]="{'invisible': !proActivityForm.valid}">&#10003;</span>
                    <button [disabled]="proGoalForm.valid ? false : true" (click)="goForward('proActivity')" [ngClass]="{'greenButton': true, 'lightGrayButton': currentSlide != 'proActivity'}">Activity</button>
                </div>
                <div class="slimButton">
                    <span class="checkSpan" [ngClass]="{'invisible': !proDietForm.valid}">&#10003;</span>
                    <button [disabled]="proActivityForm.valid ? false : true" (click)="goForward('proDiet')" [ngClass]="{'greenButton': true, 'lightGrayButton': currentSlide != 'proDiet'}">Diet</button>
                </div>

                <div class="slimButton">
                    <span class="checkSpan" *ngIf="proResultsVisited && (proDetailsForm.valid && proGoalForm.valid &&proActivityForm.valid && proDietForm.valid )">&#10003;</span>
                    <button [disabled]="(proDetailsForm.valid && proGoalForm.valid &&proActivityForm.valid && proDietForm.valid ) ? false : true" (click)="pickResultsPage()" [ngClass]="{'greenButton': true, 'lightGrayButton': currentSlide != 'proResults'}">Results</button>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-12">
            <div *ngIf="subtitle" id="subtitle">{{subtitle}}</div>
            <h2 *ngIf="title" id="title">{{title}}<img *ngIf="currentSlide=='sex'" src="assets/images/info.svg" (click)="showModal(getGenderModal())" class="gender infoButton"></h2>
            <div *ngIf="caveat" class="caveat">{{caveat}}</div>
        </div>
    </div>

    <div class="row align-self-stretch">
        <div class="col-12">
            <div id="contentFrame">

                <!-- PRO PATH -->

                <div class="content d-flex flex-column" id="proDetails">
                    <div *ngIf="!selfEdit" class="row">
                        <div class="col-12 col-md-8 offset-md-2 justify-content-center mt-3 mt-md-4">
                            <div class="inputDiv d-inline-flex">
                                <div class="btn-group btn-group-toggle" ngbRadioGroup name="clientLevelRadio" [(ngModel)]="clientLevelRadio" name="clientLevelRadio" >
                                    <label ngbButtonLabel class="btn">
                                        <input ngbButton type="radio" value="level1">Level 1 Client
                                    </label>
                                    <label ngbButtonLabel class="btn">
                                        <input ngbButton type="radio" value="level2or3">Level 2 or 3 Client
                                    </label>
                                </div>
                            </div>
                            <img src="assets/images/info.svg" (click)="showModal(contentData['proDetails'].modals.clientLevels)" class="gender infoButton">
                        </div>
                    </div>

                    <div class="row mt-md-4 justify-content-center">
                        <div *ngIf="!selfEdit" class="col-12 col-md-4 mt-3 mt-md-0 px-4"><!-- first name -->
                            <div class="inputLabel">Client's First Name</div>
                            <div class="inputDiv flex-fill d-flex">
                                <input class="smallInput flex-fill" type="text" [(ngModel)]="userName" name="userName" [(formControl)]="nameRequired" />
                            </div>
                        </div>
                        <div class="col-12 col-md-4 mt-3 mt-md-0 px-4"><!-- weight -->
                            <div class="inputLabel">Weight</div>

                            <div class="inputDiv flex-fill d-flex">
                                <input class="smallInput flex-fill" type="number" [(ngModel)]="initialWeightField" (change)="changeInitialWeightField()"  [(formControl)]="weightRange" name="initialWeightField" />

                                <div class="btn-group btn-group-toggle" ngbRadioGroup name="weightRadio" [(ngModel)]="weightUnitsRadioGroup" (change)="changeWeightUnits()">
                                    <label ngbButtonLabel class="btn">
                                        <input ngbButton type="radio" value="lbs">lbs
                                    </label>
                                    <label ngbButtonLabel class="btn">
                                        <input ngbButton type="radio" value="kg">kg
                                    </label>
                                </div>
                            </div>

                            <div *ngIf="weightUnitsRadioGroup=='lbs'" class="smallSubtext pt-1">Valid weight is 50-500 lbs</div>
                            <div *ngIf="weightUnitsRadioGroup=='kg'" class="smallSubtext pt-1">Valid weight is 23-227 kg</div>
                        </div>
                    </div>

                    <div class="row mt-md-4">
                        <div class="col-12 col-md-8 offset-md-2 px-4">
                            <div class="row">
                                <div *ngIf="heightUnitsGroup=='Inches'" class="col-6 col-md-4 mt-3 mt-md-0"><!-- height ft -->
                                    <div class="inputLabel">Height</div>
                                    <div class="inputDiv flex-fill d-flex">
                                        <input class="smallInput flex-fill" type="number" [(ngModel)]="heightFt" name="heightFt" (change)="changeHeightFeet()" min="2" max="9" [(formControl)]="feetRange" /><span>ft</span>
                                    </div>
                                    <div class="smallSubtext pt-1">Valid height is 2'-9'11" </div>
                                </div>
                                <div *ngIf="heightUnitsGroup=='Inches'" class="col-6 col-md-4 mt-3 mt-md-0"><!-- height in -->
                                    <div class="inputLabel">&nbsp;</div>
                                    <div class="inputDiv flex-fill d-flex">
                                        <input class="smallInput flex-fill" type="number" [(ngModel)]="heightIn" name="heightIn" (change)="changeHeightFeet()"  min="0" max="13" [(formControl)]="inchRange" /><span>in</span>
                                    </div>
                                    <div class="smallSubtext pt-1"></div>
                                </div>
                                <div class="col-6 col-md-8 mt-3 mt-md-0" *ngIf="heightUnitsGroup=='Centimeters'">
                                    <div class="inputLabel">Height</div>
                                    <div class="inputDiv flex-fill d-flex">
                                        <input class="smallInput flex-fill" type="number" [(ngModel)]="heightField" name="heightField" (change)="changeHeightField()"  [(formControl)]="cmRange" />
                                        <span>cm</span>
                                    </div>
                                    <div class="smallSubtext pt-1">Valid height is 60-300 cm</div>
                                </div>
                                <div class="col-6 col-md-4 mt-3 mt-md-0">
                                    <div class="inputLabel">&nbsp;</div>
                                    <div class="inputDiv flex-fill d-flex">
                                        <div class="btn-group btn-group-toggle flex-fill" ngbRadioGroup name="heightRadio" [(ngModel)]="heightUnitsGroup" name="heightUnitsGroup" (change)="changeHeightUnits()">
                                            <label ngbButtonLabel class="btn">
                                                <input ngbButton type="radio" value="Inches">ft
                                            </label>
                                            <label ngbButtonLabel class="btn">
                                                <input ngbButton type="radio" value="Centimeters">cm
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-md-4" [ngClass]="{'pb-4' : clientLevelRadio == 'level1'}">
                        <div class="col-12 col-md-8 offset-md-2 px-4">
                            <div class="row">
                                <div class="col-6 mt-3 mt-md-0"><!-- sex -->
                                    <div class="inputLabel">Sex <img src="assets/images/info.svg" (click)="showModal(contentData['sex'].modal)" class="gender infoButton"></div>
                                    <div class="inputDiv flex-fill d-flex">
                                        <div class="btn-group btn-group-toggle flex-fill" ngbRadioGroup name="sexRadio" [(ngModel)]="genderBox" name="genderBox" (change)="genderChange(genderBox)" [(formControl)]="genderRange">
                                            <label ngbButtonLabel class="btn">
                                                <input ngbButton type="radio" value="Male">Male
                                            </label>
                                            <label ngbButtonLabel class="btn">
                                                <input ngbButton type="radio" value="Female">Female
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6 mt-3 mt-md-0"><!-- age -->
                                    <div class="inputLabel">Age</div>
                                    <div class="inputDiv flex-fill d-flex">
                                        <input class="smallInput flex-fill" type="number" [(ngModel)]="ageField" name="ageField" (change)="changeAgeField()" min="18" max="120"  [(formControl)]="ageRange" />
                                    </div>
                                    <div class="smallSubtext pt-1">Valid age is 18-120</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="clientLevelRadio=='level2or3'" class="row mt-md-4">
                        <div class="col-12 col-md-4 offset-md-2 mt-3 mt-md-0 px-4"><!-- *body fat InitialBfpField -->
                            <div class="inputLabel">% Body Fat<img src="assets/images/info.svg" (click)="showModal(contentData['proDetails'].modals.bodyFat)" class="gender infoButton"></div>
                            <div class="inputDiv flex-fill d-flex">
                                <input class="smallInput flex-fill" type="number" [(ngModel)]="InitialBfpField" name="InitialBfpField" (change)="changeBfpField()" [attr.disabled]="bfpCalcDisabled ? true : null" [(formControl)]="bfpRange" />

                                <div class="btn-group btn-group-toggle" ngbRadioGroup name="changeBfpRadio" (change)="changeBfpInput()" [(ngModel)]="bfpCalcAuto">
                                    <label ngbButtonLabel class="btn">
                                        <input ngbButton type="radio" value="true">est
                                    </label>
                                    <label ngbButtonLabel class="btn">
                                        <input ngbButton type="radio" value="false">custom
                                    </label>
                                </div>
                            </div>
                            <div class="smallSubtext pt-1">Valid range is 3-65%</div>
                        </div>
                        <div class="col-12 col-md-4 mt-3 mt-md-0 px-4 pb-4"><!-- *metabolid rate initialRMRField -->
                            <div class="inputLabel">Resting Metabolic Rate (Cal/day)</div>
                            <div class="inputDiv flex-fill d-flex">
                                <input class="smallInput flex-fill" type="number" [(ngModel)]="initialRMRField" name="initialRMRField" (change)="changeRMRField()" [attr.disabled]="rmrCalcDisabled ? true : null" [(formControl)]="rmrRange" />

                                <div class="btn-group btn-group-toggle" ngbRadioGroup name="changeRmrInput" (change)="changeRmrInput()" [(ngModel)]="rmrCalcAuto">
                                    <label ngbButtonLabel class="btn">
                                        <input ngbButton type="radio" value="true">est
                                    </label>
                                    <label ngbButtonLabel class="btn">
                                        <input ngbButton type="radio" value="false">custom
                                    </label>
                                </div>
                            </div>
                            <div class="smallSubtext pt-1">Valid range is 500-5000</div>
                        </div>
                    </div>
                    <div class="mt-auto">
                        <button [attr.disabled]="proDetailsForm.valid ? null : true" (click)="goForward('proGoal')" class="greenButton mb-3">Next</button>
                    </div>                   
                </div>


                <div class="content d-flex flex-column" id="proActivity" [formGroup]="proActivityForm">
                    <div class="row mt-md-4">
                        <!-- exercise -->
                        <div class="col-12 col-md-4 offset-md-2 mt-3 mt-md-0 px-4">
                            <div class="inputLabel mb-sm-0 mb-md-4">Weekly purposeful exercise</div>
                            <div class="inputDiv flex-fill">
                                <mat-form-field>
                                    <mat-select [(value)]="ExerciseLevel" formControlName="exercisePref" (change)="calculatePAL()">
                                        <mat-option *ngFor="let option of contentData['exercise'].options" [value]="option.value">
                                            {{option.value}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div *ngIf="ExerciseLevel" class="smallSubtext pt-1">{{getExerciseSubtitle()}}</div>
                        </div>
                        <!-- acivity -->
                        <div class="col-12 col-md-4 mt-3 mt-md-0 px-4">
                            <div class="inputLabel">Daily activity level excluding purposeful exercise</div>
                            <div class="inputDiv flex-fill">
                                <mat-form-field>
                                    <mat-select [(value)]="WorkActivityLevel" formControlName="activityPref" (change)="calculatePAL()">
                                        <mat-option *ngFor="let option of contentData['activity'].options" [value]="option.value">
                                            {{option.value}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div *ngIf="WorkActivityLevel" class="smallSubtext pt-1">{{getActivitySubtitle()}}</div>
                        </div>
                    </div>

                    <div class="row mt-md-4">
                        <div class="col-12 col-md-4 offset-md-4 mt-3 mt-md-0 px-4">
                            <div class="inputLabel">Physical Activity Multiplier<img src="assets/images/info.svg" (click)="showModal(contentData['proActivity'].modal)" class="gender infoButton"></div>
                            <div class="inputDiv flex-fill d-flex">
                                <input class="smallInput flex-fill" type="number" [(ngModel)]="PALOverride" formControlName="palRange" (change)="overridePAL()" />
                                <div class="btn-group btn-group-toggle" ngbRadioGroup (change)="changePalCustEstToggle()" [(ngModel)]="palCustEstToggle" formControlName="palCustEstToggleFC">
                                    <label ngbButtonLabel class="btn">
                                        <input ngbButton type="radio" value='true'>est
                                    </label>
                                    <label ngbButtonLabel class="btn">
                                        <input ngbButton type="radio" value='false'>custom
                                    </label>
                                </div>
                            </div>
                            <div class="smallSubtext pt-1">Valid range is 1.11-3</div>
                        </div>
                    </div>                   
                    
                    <div *ngIf="palCustEstToggle=='false'" class="row my-md-4">
                        <div class="col-12 col-md-4 offset-md-4 mt-3 mt-md-0 px-4">
                            <div class="redWarning d-flex flex-fill" style="height:36px;">
                                <div class="h-100">
                                    <fa-icon [icon]="faExclamationTriangle" ></fa-icon>
                                </div>
                                <div class="h-100 d-flex flex-fill">
                                    <div class="my-auto ml-1 text-left">If you customize the physical activity multiplier you will override the calculator’s initial estimations.</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="mt-3">
                        <button [attr.disabled]="proActivityForm.valid ? null : true" (click)="goForward('proDiet')" class="greenButton mb-3">Next</button>
                    </div>
                </div>


                <div class="content d-flex flex-column" id="proDiet" [formGroup]="proDietForm">
                    <div class="row mt-md-4">
                        <!-- diet -->
                        <div class="col-12 col-md-4 offset-md-2 mt-3 mt-md-0 px-4">
                            <div class="inputLabel">Dietary Preference</div>
                            <div class="inputDiv flex-fill">
                                <mat-form-field>
                                    <mat-select [(value)]="dietaryPreference" (change)="setRecommendedFoods()" formControlName="dietPref">
                                        <mat-option *ngFor="let option of contentData.diet.options" [value]="option.value">
                                            {{option.value}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div *ngIf="dietaryPreference" class="smallSubtext pt-1">{{getDietSubtitle()}}</div>
                        </div>
                        <!-- Custom macro ratios -->
                        <div class="col-12 col-md-4 mt-3 mt-md-0 px-4">
                            <div class="inputLabel">Macronutrient Ratio<img src="assets/images/info.svg" (click)="showModal(contentData['proDiet'].modals.macroRatio)" class="gender infoButton"></div>
                            <div class="inputDiv flex-fill">
                                <mat-form-field>
                                    <mat-select [disabled]="dietaryPreference?null:true" [(value)]="macroPreference" formControlName="macroPref">
                                        <mat-option *ngFor="let option of filteredMacroOptions" [value]="option.value" (click)="setNormalMacros()">
                                            {{option.value}}
                                        </mat-option>

                                        <mat-option value="Customize Macro Percentages" (click)="enableCustomMacroPercentages()">Customize Macro Percentages</mat-option>

                                        <mat-option value="Customize Macro Grams" (click)="enableCalculateCustomMacros()">Customize Macro Grams</mat-option>

                                        <mat-option value="Enter Desired Macro Totals" (click)="enableCustomMacroGrams()">Enter Desired Macro Totals</mat-option>
                                        
                                        <mat-option value="Enter Desired Hand Portions" (click)="enableCustomMacroPalms()">Enter Desired Hand Portions</mat-option>                                        
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div *ngIf="macroPreference" class="smallSubtext pt-1" [innerHTML]="getMacroSubtitle()"></div>
                        </div>
                    </div>

                    <!-- Custom macro percentages -->
                    <div *ngIf="customMacroPercentages" class="row mt-md-2">
                        <!-- SLIDER BLOCK -->
                        <div class="col-12 col-md-8 offset-md-2 mt-4 mt-md-0 px-4">
                            <div class="row">
                                <div class="col-10 offset-1">
                                    <div class="slider">
                                        <span class="fontBlue">Protein</span>
                                        <mat-slider thumbLabel [(ngModel)]="customProteinPercent" class="alternate-theme" (input)="sliderInput($event, 'protein')" (change)="sliderChange($event,'protein')" appSliderLimits [macro]="'protein'" [map]="dietMapping" [path]="calcPath"  [diet]="dietaryPreference" [displayWith]="formatSliderLabel" formControlName="protPerc"></mat-slider>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-10 offset-1">
                                    <div class="slider">
                                        <span class="fontOrange">Carb</span>
                                        <mat-slider thumbLabel  [(ngModel)]="customCarbPercent" class="alternate-theme" (input)="sliderInput($event, 'carbs')" (change)="sliderChange($event,'carbs')" appSliderLimits [macro]="'carbs'" [map]="dietMapping" [path]="calcPath" [diet]="dietaryPreference" [displayWith]="formatSliderLabel" formControlName="carbPerc"></mat-slider>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-10 offset-1">
                                    <div class="slider">
                                        <span class="fontYellow">Fat</span>
                                        <mat-slider thumbLabel  [(ngModel)]="customFatPercent" class="alternate-theme" (input)="sliderInput($event, 'fat')" (change)="sliderChange($event,'fat')" appSliderLimits [macro]="'fat'" [map]="dietMapping" [path]="calcPath" [diet]="dietaryPreference" [displayWith]="formatSliderLabel" formControlName="fatPerc"></mat-slider>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-md-8 offset-md-2 px-4">
                                <div class="row my-4">
                                    <div class="col-4 mt-3 mt-md-0 handCell"><!-- *cust protein -->            <span class='fontBlue'>Protein</span>      
                                        <div class="d-flex flex-column font40">
                                            <div class="mb-3 d-flex flex-row">
                                                <div class="smallInput largeNumber fontBlue flex-fill">
                                                    {{customProteinGrams}}
                                                </div><div>g</div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="col-4 mt-3 mt-md-0 handCell"><!-- *cust protein -->             <span class='fontOrange'>Carbs</span>  
                                        <div class="d-flex flex-column font40">
                                            <div class="mb-3 d-flex flex-row">
                                                <div class="smallInput largeNumber fontOrange flex-fill">
                                                    {{customCarbGrams}}
                                                </div><div>g</div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="col-4 mt-3 mt-md-0"><!-- *cust protein -->                      <span class='fontYellow'>Fat</span>  
                                        <div class="d-flex flex-column font40">
                                            <div class="mb-3 d-flex flex-row">
                                                <div class="smallInput largeNumber fontYellow flex-fill">
                                                    {{customFatGrams}}
                                                </div><div>g</div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                            
                            <!--div class="row">
                                <div class="col-12">
                                    <div class="text-center">
                                        <span class="checkSpan" *ngIf="totalCustomPercent == 100">&#10003;</span> Total: <b>{{totalCustomPercent || 0}}%</b>
                                        <br /> <i>*Macronutrient percentages must add up to 100%.</i>
                                        <input type="hidden" [(ngModel)]="totalCustomPercent" />
                                    </div>
                                </div>
                            </div-->

                        </div>
                    </div>
                    <!-- Custom macro grams -->
                    <div *ngIf="customMacroGrams" class="row mt-md-2">
                        <div class="col-12 col-md-8 offset-md-2 px-4">
                            <div class="row">
                                <div class="col-4 mt-3 mt-md-0"><!-- *cust protein -->
                                    <div class="inputLabel">Protein</div>
                                    <div class="inputDiv flex-fill d-flex">
                                        <input class="smallInput flex-fill" type="number" [(ngModel)]="customProteinGrams"  formControlName="protGrams"/><span>g</span>
                                    </div>
                                    <div class="smallSubtext pt-1">valid protein: 50-500 g</div>
                                </div>
                                <div class="col-4 mt-3 mt-md-0"><!-- *cust carbs -->
                                    <div class="inputLabel fontOrange">Carbs</div>
                                    <div class="inputDiv flex-fill d-flex">
                                        <input class="smallInput flex-fill" type="number" [(ngModel)]="customCarbGrams"  formControlName="carbGrams"/><span>g</span>
                                    </div>
                                    <div class="smallSubtext pt-1">valid carbs: 0-1000 g</div>
                                </div>
                                <div class="col-4 mt-3 mt-md-0"><!-- *cust fat -->
                                    <div class="inputLabel fontYellow">Fat</div>
                                    <div class="inputDiv flex-fill d-flex">
                                        <input class="smallInput flex-fill" type="number" [(ngModel)]="customFatGrams"  formControlName="fatGrams"/><span>g</span>
                                    </div>
                                    <div class="smallSubtext pt-1">valid fats: 25-500 g</div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-md-8 offset-md-2 px-4">
                            <div class="redWarning d-flex flex-fill" style="height:36px;">
                                <div class="h-100">
                                    <fa-icon [icon]="faExclamationTriangle" ></fa-icon>
                                </div>
                                <div class="h-100 d-flex flex-fill">
                                    <div class="my-auto ml-1 text-left">If you customize your macro totals you will override the calculator's results.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Custom macro palms -->
                    <div *ngIf="customMacroPalms" class="row mt-md-2">
                        <div class="col-12 col-md-8 offset-md-2 px-4">
                            <div class="row">
                                <div class="col-3 mt-2 mt-md-0">
                                    <div class="inputLabel">Protein</div>
                                    <div class="inputDiv flex-fill d-flex">
                                        <input class="smallInput flex-fill" type="number" [(ngModel)]="customProteinPalms"  formControlName="protPalms" />
                                    </div>
                                    <div class="smallSubtext pt-1">2-20 Palms</div>
                                </div>
                                <div class="col-3 mt-2 mt-md-0">
                                    <div class="inputLabel fontGreen">Veggies</div>
                                    <div class="inputDiv flex-fill d-flex">
                                        <input class="smallInput flex-fill" type="number" [(ngModel)]="customFistsVeggies"  formControlName="vegFists" />
                                    </div>
                                    <div class="smallSubtext pt-1">1-20 Fists</div>
                                </div>
                                <div class="col-3 mt-2 mt-md-0">
                                    <div class="inputLabel fontOrange">Carbs</div>
                                    <div class="inputDiv flex-fill d-flex">
                                        <input class="smallInput flex-fill" type="number" [(ngModel)]="customCarbHandfuls"  formControlName="carbHands" />
                                    </div>
                                    <div class="smallSubtext pt-1">0-40 Handfuls</div>
                                </div>
                                <div class="col-3 mt-2 mt-md-0">
                                    <div class="inputLabel fontYellow">Fat</div>
                                    <div class="inputDiv flex-fill d-flex">
                                        <input class="smallInput flex-fill" type="number" [(ngModel)]="customFatThumbs"  formControlName="fatThumbs" />
                                    </div>
                                    <div class="smallSubtext pt-1">0-40 Thumbs</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-8 offset-md-2 px-4">
                            <div class="redWarning d-flex flex-fill" style="height:36px;">
                                <div class="h-100">
                                    <fa-icon [icon]="faExclamationTriangle" ></fa-icon>
                                </div>
                                <div class="h-100 d-flex flex-fill">
                                    <div class="my-auto ml-1 text-left">If you customize your hand portion totals, you will override the calculator’s results.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Calculate Macro Totals-->
                    <div *ngIf="calculateCustomMacros" class="row mt-md-2">                        
                            <!-- custom macro combo toggle-->           
                        <div class="col-12 col-md-4 offset-md-2 mt-4 mt-md-0 px-4">
                            <div class="inputDiv flex-fill d-flex">
                                <div class="btn-group btn-group-toggle flex-fill" ngbRadioGroup [(ngModel)]="custMacCalcCombo" formControlName="custMacCalcComboFC">
                                    <label ngbButtonLabel class="btn">
                                        <input ngbButton type="radio" value="ProteinCarb">Protein + Carb
                                    </label>
                                    <label ngbButtonLabel class="btn">
                                        <input ngbButton type="radio" value="ProteinFat">Protein + Fat
                                    </label>
                                </div>
                            </div>
                        </div>

                        <!-- custom macro g/? toggle -->
                        <div class="col-12 col-md-4 mt-4 mt-md-0 px-4"> 
                            <div class="inputDiv flex-fill d-flex">
                                <div class="btn-group btn-group-toggle flex-fill" ngbRadioGroup [(ngModel)]="custMacCalcGramPer" formControlName="custMacCalcGramPerFC" (change)="calcCustomMacros()">
                                    <label ngbButtonLabel class="btn">
                                        <input ngbButton type="radio" value="glb">g/lb
                                    </label>
                                    <label ngbButtonLabel class="btn">
                                        <input ngbButton type="radio" value="gkg">g/kg
                                    </label>
                                </div>
                            </div>                                                       
                        </div>
                        
                        <!--Cust Calc prot/carb/fat input-->
                        <div class="col-12 col-md-8 offset-md-2 px-4">
                            <div class="row my-4">
                                <div class="col-4 mt-4 mt-md-0">
                                    <div class="inputLabel">Protein<img src="assets/images/info.svg" (click)="showModal(contentData['proDiet'].modals.customCalc)" class="gender infoButton"></div>
                                    <div class="inputDiv flex-fill d-flex">
                                        <input class="smallInput flex-fill" type="number" [(ngModel)]="custMacroCalcProtMultiplier"  formControlName="custMacroCalcProtMultiplierFC" (change)="calcCustomMacros()"/>
                                    </div>
                                    <div *ngIf="custMacCalcGramPer=='glb'" class="smallSubtext pt-1">0.55-1.5 g/lb</div>
                                    <div *ngIf="custMacCalcGramPer=='gkg'" class="smallSubtext pt-1">1.2-3.3 g/kg</div>
                                </div>
                                <div class="col-4 mt-4 mt-md-0">
                                    <div class="inputLabel fontOrange">Carbs</div>
                                    <div [ngClass]="{'hiddenInput' : custMacCalcCombo == 'ProteinFat'}">
                                        <div class="inputDiv flex-fill d-flex">
                                            <input class="smallInput flex-fill" type="number" [(ngModel)]="custMacroCalcCarbMultiplier"  formControlName="custMacroCalcCarbMultiplierFC" (change)="calcCustomMacros()"/>
                                        </div>
                                        <div *ngIf="custMacCalcGramPer=='glb'" class="smallSubtext pt-1">0-5.5 g/lb
                                            </div>
                                        <div *ngIf="custMacCalcGramPer=='gkg'" class="smallSubtext pt-1">0-12 g/kg</div>
                                    </div>
                                </div>
                                <div class="col-4 mt-4 mt-md-0">
                                    <div class="inputLabel fontYellow">Fat</div>
                                    <div [ngClass]="{'hiddenInput' : custMacCalcCombo == 'ProteinCarb'}">
                                        <div class="inputDiv flex-fill d-flex">
                                            <input class="smallInput flex-fill" type="number" [(ngModel)]="custMacroCalcFatMultiplier"  formControlName="custMacroCalcFatMultiplierFC" (change)="calcCustomMacros()"/>
                                        </div>
                                        <div *ngIf="custMacCalcGramPer=='glb'" class="smallSubtext pt-1">0.2-2.0 g/lb</div>
                                        <div *ngIf="custMacCalcGramPer=='gkg'" class="smallSubtext pt-1">0.4-4.5 g/kg</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-md-8 offset-md-2 mt-4 mb-2 px-4 text-center">
                            <div>
                                <b>Calculated Results</b>
                            </div>
                        </div>
                        <!-- custom calc prot output -->
                        <div class="col-12 col-md-8 offset-md-2 px-4">
                            <div class="row my-4">
                                <div class="col-4 mt-3 mt-md-0 handCell"><!-- *cust protein -->                  
                                    <div class="d-flex flex-column font40">
                                        <div class="mb-3 d-flex flex-row">
                                            <div class="smallInput largeNumber fontBlue flex-fill">
                                                {{customProteinGrams}}
                                            </div><div>g</div>
                                        </div>                                        
                                        <div class="d-flex flex-row">              
                                            <div class="smallInput largeNumber fontBlue flex-fill">
                                                {{customProteinPercent}}
                                            </div><div>%</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-4 mt-3 mt-md-0 handCell"><!-- *cust protein -->                  
                                    <div class="d-flex flex-column font40">
                                        <div class="mb-3 d-flex flex-row">
                                            <div class="smallInput largeNumber fontOrange flex-fill">
                                                {{customCarbGrams}}
                                            </div><div>g</div>
                                        </div>                                        
                                        <div class="d-flex flex-row">              
                                            <div class="smallInput largeNumber fontOrange flex-fill">
                                                {{customCarbPercent}}
                                            </div><div>%</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-4 mt-3 mt-md-0"><!-- *cust protein -->                  
                                    <div class="d-flex flex-column font40">
                                        <div class="mb-3 d-flex flex-row">
                                            <div class="smallInput largeNumber fontYellow flex-fill">
                                                {{customFatGrams}}
                                            </div><div>g</div>
                                        </div>                                        
                                        <div class="d-flex flex-row">              
                                            <div class="smallInput largeNumber fontYellow flex-fill">
                                                {{customFatPercent}}
                                            </div><div>%</div>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>

                        <div class="col-12 col-md-8 offset-md-2 px-4">
                            <div class="row my-4">                                
                                <div class="col-6 col-md-3 mt-3 mt-md-0"><!-- *cust carbs -->
                                    <div class="text-right">
                                        Estimated Goal Calories
                                    </div>
                                </div>
                                <div class="col-6 col-md-3 mt-md-0"><!-- *cust fat -->
                                    
                                        <div class="smallInput largeNumber flex-fill font40">{{goalCalsField}}</div>
                                    
                                </div>
                                <div class="col-6 col-md-3 mt-md-0"><!-- *cust carbs -->
                                    <div class="text-right">
                                        Remaining Calories
                                    </div>
                                </div>
                                <div class="col-6 col-md-3 mt-md-0"><!-- *cust fat -->                                    
                                    <input type="hidden" [(ngModel)]="remainingCals" formControlName="remainingCalsFC"/>
                                    <div class="smallInput largeNumber flex-fill font40 invalidateMe" [ngClass]="{'ng-invalid': remainingCals < -5 || customCarbPercent < 0 || customFatPercent < 0}">{{remainingCals}}</div>                            
                                </div>
                            </div>
                        </div>

                    </div>
                    
                    <!-- Meals Per Day -->
                    <div class="row mt-md-4">
                        <div class="col-12 col-md-4 offset-md-4 mt-3 mt-md-0 px-4">
                            <div class="inputLabel">Meals per day</div>
                            <div class="inputDiv flex-fill d-flex">
                                <input class="smallInput flex-fill" type="number" [(ngModel)]="mealsPerDay" formControlName="mealsRange" />
                            </div>
                            <div class="smallSubtext pt-1">Valid input is 1-8 meals</div>
                        </div>
                    </div>

                    <div class="mt-auto">
                        <button [attr.disabled]="proDietForm.valid ? null : true" (click)="goForward('proResults')" class="greenButton mb-3">Next</button>
                    </div>
                    <!--p>proDietForm.valid: {{proDietForm.valid}}</p>
                    <p>proDietForm.value: {{proDietForm.value | json}}</p>
                    <p>proDietForm.errors: {{proDietForm.errors | json}}</p-->
                </div>


                <div class="content d-flex flex-column" id="proGoal" [formGroup]="proGoalForm">
                    <div class="row mt-md-4">
                        <div class="col-12 col-md-8 offset-md-2">
                            <div class="row justify-content-center">
                                <!-- goal -->
                                <div class="col-12 col-md-6 mt-3 mt-md-0 px-4">
                                    <div class="inputLabel">Select a Goal</div>
                                    <div class="inputDiv flex-fill">
                                        <mat-form-field>
                                            <mat-select [(value)]="goalPreference" formControlName="goalRequired" (selectionChange)="goalChange(false)">
                                                <mat-option *ngFor="let option of contentData.goal.options" [value]="option.value">
                                                    {{option.value}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div *ngIf="goalPreference" class="smallSubtext pt-1">{{getGoalSubtitle()}}</div>
                                </div>

                                <!-- *goal weight -->
                                <div *ngIf="goalPreference=='Lose Weight'||goalPreference=='Build Muscle'" class="col-12 col-md-6 mt-3 mt-md-0 px-4"><!-- weight -->
                                    <div class="inputLabel">Goal Weight</div>
                                    <div class="inputDiv flex-fill d-flex">
                                        <input class="smallInput flex-fill" type="number" [(ngModel)]="goalWeight" (change)="changeInitialWeightField()"  formControlName="goalWeightRange" />

                                        <div class="btn-group btn-group-toggle" ngbRadioGroup name="weightRadio" [(ngModel)]="weightUnitsRadioGroup" (change)="changeWeightUnits()" formControlName="lbsValidator">
                                            <label ngbButtonLabel class="btn">
                                                <input ngbButton type="radio" value="lbs">lbs
                                            </label>
                                            <label ngbButtonLabel class="btn">
                                                <input ngbButton type="radio" value="kg">kg
                                            </label>
                                        </div>
                                    </div>
                                    <div *ngIf="weightUnitsRadioGroup=='lbs'" class="smallSubtext pt-1">Valid weight is 50-500 lbs</div>
                                    <div *ngIf="weightUnitsRadioGroup=='kg'" class="smallSubtext pt-1">Valid weight is 23-227 kg</div>
                                </div>

                                <div *ngIf="goalPreference=='Lose Weight'||goalPreference=='Build Muscle'" class="col-12 col-md-6 mt-3 mt-md-0 px-4 py-4">
                                <!-- goal date -->
                                    <div class="inputLabel">Goal Completion Date</div>
                                    <div class="inputDiv flex-fill d-flex">
                                        <mat-form-field class="example-full-width">
                                            <input matInput [matDatepicker]="proPicker" [min]="today" [(ngModel)]="targetDate" formControlName="targetDateControl">
                                            <mat-datepicker-toggle matSuffix [for]="proPicker" class="mx-auto"></mat-datepicker-toggle>
                                            <mat-datepicker touchUi #proPicker [startAt]="today" ></mat-datepicker>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row mt-md-4 smallerizeFont" *ngIf="genderBox && (goalPreference=='Lose Weight' || goalPreference=='Build Muscle') ">
                        <div class="col-12 col-md-8 offset-md-2 px-4">
                            <div >
                                <div class="row mt-md-4">
                                    <div class="col-12">
                                        <div class="inputLabel fontBlue">Time Frame Estimates <img src="assets/images/info.svg" (click)="showModal(contentData['proGoal'].modal)" class="gender infoButton"></div>
                                    </div>
                                </div>
                                <div *ngFor="let range of goalProjection[goalPreference][genderBox]" class="row mt-md-4">
                                    <div *ngIf="range.to && range.from" class="col-12 text-left pt-3">
                                        {{range.label}}: {{range.from}} to {{range.to}} {{range.unit}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="mt-auto">
                        <button [attr.disabled]="proGoalForm.valid ? null : true" (click)="goForward('proActivity')" class="greenButton mb-3">Next</button>
                    </div>              
                </div>


                <div class="content d-flex flex-column" id="proResults">
                    <div class="row">
                        <div class="col-12 col-md-6 offset-md-3 mb-3">
                            <div class="mx-3">
                                <h2 class="mt-4 mb-3">{{userName | titlecase}}'s Results</h2>

                                <div class="font18">
                                    We’ve created a personalized eating guide for {{userName | titlecase}}'s body, activity levels, eating preferences, and goals.
                                </div>
                                <div class="smallLabel mt-2">
                                    (Brief summary below)
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-md-6 offset-md-3 mt-3">
                            <button class="my-4 greenButton" (click)="goForward('proEmail')">Download {{userName | titlecase}}'s complete guide</button>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-md-8 offset-md-2 my-4">
                            <div class="horizontalLine"></div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-md-6 offset-md-3 text-left">
                            <div class="mb-2">
                                <h2>Brief Summary</h2>
                            </div>

                            <div class="font18 fontGray">
                                    <div><span class='foat-left'><fa-icon [icon]="faFlagCheckered"></fa-icon>Goal</span><span class="float-right"><b>{{goalPreference}}</b></span></div>
                                </div>

                            <div class="horizontalLine my-2"></div>

                            <div class="font18 fontGray">
                                <div><span class='foat-left'><fa-icon [icon]="faUser"></fa-icon>Age</span><span class="float-right"><b>{{ageField}}</b></span></div>
                            </div>

                            <div class="horizontalLine my-2"></div>

                            <div class="font18 fontGray">
                                <div><span class='foat-left'><fa-icon [icon]="faWeight"></fa-icon>Current Weight</span><span class="float-right"><b>{{initialWeightField | number:'1.0-0'}}{{weightUnitsRadioGroup}}</b></span></div>
                            </div>

                            <div class="horizontalLine my-2"></div>

                            <div *ngIf="goalPreference=='Lose Weight'||goalPreference=='Build Muscle'">
                                <div class="font18 fontGray">
                                    <div><span class='foat-left'><fa-icon [icon]="faBullseye"></fa-icon>Target Weight</span><span class="float-right"><b>{{goalWeight | number:'1.0-0'}}{{weightUnitsRadioGroup}}</b></span></div>
                                </div>

                                <div class="horizontalLine my-2"></div>

                                <div class="font18 fontGray">
                                    <div><span class='foat-left'><fa-icon [icon]="faCalendarAlt"></fa-icon>Number of days</span><span class="float-right"><b>{{goalTime}}</b></span></div>
                                </div>

                                <div class="horizontalLine my-2"></div>
                            </div>

                            <div class="font18 fontGray">
                                <div><span class='foat-left'><fa-icon [icon]="faUtensils"></fa-icon>Eating Style</span><span class="float-right"><b>{{dietaryPreference}}</b></span></div>
                            </div>

                            <div class="horizontalLine my-2"></div>

                            <div class="font18 fontGray">
                                <div>
                                    <span class='foat-left'><fa-icon [icon]="faChartPie">
                                    </fa-icon>Macro Percentages</span>

                                    <span class="float-right text-left">
                                        <b class="fontBlue"><span *ngIf="customMacroAdjustType!='own'&&macroPreference!='Very low-carb'&&macroPreference!=='Very low-fat'" class="tilda">~</span>{{finalProteinPercentage}}% Protein</b><br class="d-md-none"/>
                                        <b class="fontOrange ml-md-3"><span *ngIf="customMacroAdjustType!='own'&&macroPreference!='Very low-carb'&&macroPreference!=='Very low-fat'" class="tilda">~</span>{{finalCarbsPercentage}}% Carbs</b><br class="d-md-none"/>
                                        <b class="fontYellow ml-md-3"><span *ngIf="customMacroAdjustType!='own'&&macroPreference!='Very low-carb'&&macroPreference!=='Very low-fat'" class="tilda">~</span>{{finalFatPercentage}}% Fat</b><br class="d-md-none"/>
                                    </span>

                                </div>
                                <div class="clear"></div>
                            </div>

                            <div class="horizontalLine mt-2 mb-5"></div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-md-6 offset-md-3 mb-4">
                            <h2>Calories, Macros, & Portions</h2>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-md-6 offset-md-3 text-left">

                            <div *ngIf="goalPreference=='Lose Weight'||goalPreference=='Build Muscle'" class="font18 fontGray">
                                <div><span class='foat-left'>Maintenance Calories</span><span class="float-right">{{maintCalsField | number:'1.0-0'}}/day</span></div>
                            </div>

                            <div *ngIf="goalPreference=='Lose Weight'||goalPreference=='Build Muscle'" class="horizontalLine my-2"></div>

                            <div *ngIf="!customMacroGrams && !customMacroPalms" class="font22 fontGray">
                                <div><span class='foat-left'><b>Goal Calories</b></span><span class="float-right"><b class="fontBlue">{{goalCalsField | number:'1.0-0'}}/day</b></span></div>
                            </div>

                            <div *ngIf="customMacroGrams || customMacroPalms" class="font18 fontGray">
                                <div><span class='foat-left'>Goal Calories</span><span class="float-right">{{goalCalsField | number:'1.0-0'}}/day</span></div>
                            </div>

                            <div class="horizontalLine my-2"></div>

                            <div *ngIf="customMacroGrams || customMacroPalms" class="font22 fontGray">
                                <div><span class='foat-left'><b>Custom Calories</b></span><span class="float-right"><b class="fontBlue">{{customDietCalories | number:'1.0-0'}}/day</b></span></div>
                            </div>

                            <div *ngIf="customMacroGrams || customMacroPalms" class="horizontalLine my-2"></div>

                            <div class="font18 fontGray text-center halfOpacity my-3"><b>HERE'S HOW THAT BREAKS DOWN:</b></div>
                        </div>
                    </div>

                    <div class="row">
                        <!-- PALMS PROTEIN -->
                        <div class="col-12 col-md-6 offset-md-3 border-top">
                            <div class="row text-left">
                                <div class="col-3">
                                    <div class="d-flex h-100 justify-content-center align-items-center handCell">
                                        <img class="my-auto" src="assets/images/palm.svg">
                                    </div>
                                </div>

                                <div class="col-9 copyCol">
                                    <div class="font18">
                                        <b>{{totalPalms}} palm-sized portions (or {{totalProtein}}g) of <span class="fontBlue">protein</span> per day</b>
                                    </div>
                                    <div class="font14">
                                        That's <b>{{perMealPalms}} total palms</b> or <b>{{perMealProtein}}g</b> per meal.
                                    </div>
                                    <div class="font14">
                                        <span class="fontBlue">FOR EXAMPLE</span><br />
                                        <div class="row forExample">
                                            <div class="col-5">
                                                <span class="dot blue"></span>{{recommendedFoods.protein[0]}}<br />
                                                <span class="dot blue"></span>{{recommendedFoods.protein[1]}}
                                            </div>
                                            <div class="col-6">
                                                <span class="dot blue"></span>{{recommendedFoods.protein[2]}}<br />
                                                <span class="dot blue"></span>{{recommendedFoods.protein[3]}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- FISTS VEGGIES -->
                        <div class="col-12 col-md-6 offset-md-3 border-top">
                            <div class="row text-left">
                                <div class="col-3">
                                    <div class="d-flex h-100 justify-content-center align-items-center handCell">
                                        <img class="my-auto" src="assets/images/fist.svg">
                                    </div>
                                </div>

                                <div class="col-9 copyCol">
                                    <div class="font18">
                                        <b>{{totalFists}} fist-sized portions of <span class="fontGreen">veggies</span> per day</b>
                                    </div>
                                    <div class="font14">
                                        That's <b>{{perMealFists}} total fists</b> per meal.
                                    </div>
                                    <div class="font14">
                                        <span class="fontGreen">FOR EXAMPLE</span><br />
                                        <div class="row forExample">
                                            <div class="col-5">
                                                <span class="dot green"></span>{{recommendedFoods.veggies[0]}}<br />
                                                <span class="dot green"></span>{{recommendedFoods.veggies[1]}}
                                            </div>
                                            <div class="col-6">
                                                <span class="dot green"></span>{{recommendedFoods.veggies[2]}}<br />
                                                <span class="dot green"></span>{{recommendedFoods.veggies[3]}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="row">
                        <!-- HANDFULS CARBS -->
                        <div class="col-12 col-md-6 offset-md-3 border-top">
                            <div class="row text-left">
                                <div class="col-3">
                                    <div class="d-flex h-100 justify-content-center align-items-center handCell">
                                        <img class="my-auto" src="assets/images/cupped.svg">
                                    </div>
                                </div>

                                <div class="col-9 copyCol">
                                    <div class="font18">
                                        <b>{{totalHandfuls}} cupped handfuls (or {{totalCarbs}}g) of <span class="fontOrange">carbs</span> per day</b>
                                    </div>
                                    <div class="font14">
                                        That's <b>{{perMealHandfuls}} total handfuls</b> or <b>{{perMealCarbs}}g</b> per meal.
                                    </div>
                                    <div class="font14">
                                        <span class="fontOrange">FOR EXAMPLE</span><br />
                                        <div class="row forExample">
                                            <div class="col-5">
                                                <span class="dot orange"></span>{{recommendedFoods.carbs[0]}}<br />
                                                <span class="dot orange"></span>{{recommendedFoods.carbs[1]}}
                                            </div>
                                            <div class="col-6">
                                                <span class="dot orange"></span>{{recommendedFoods.carbs[2]}}<br />
                                                <span class="dot orange"></span>{{recommendedFoods.carbs[3]}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- THUMBS FATS -->
                        <div class="col-12 col-md-6 offset-md-3 border-top border-bottom">
                            <div class="row text-left">
                                <div class="col-3">
                                    <div class="d-flex h-100 justify-content-center align-items-center handCell">
                                        <img class="my-auto" src="assets/images/thumb.svg">
                                    </div>
                                </div>

                                <div class="col-9 copyCol">
                                    <div class="font18">
                                        <b>{{totalThumbs}} thumb-sized portion (or {{totalFats}}g) of <span class="fontYellow">healthy fats</span> per day</b>
                                    </div>
                                    <div class="font14">
                                        That's <b>{{perMealThumbs}} total thumbs</b> or <b>{{perMealFats}}g</b> per meal.
                                    </div>
                                    <div class="font14">
                                        <span class="fontYellow">FOR EXAMPLE</span><br />
                                        <div class="row forExample">
                                            <div class="col-5">
                                                <span class="dot yellow"></span>{{recommendedFoods.fat[0]}}<br />
                                                <span class="dot yellow"></span>{{recommendedFoods.fat[1]}}
                                            </div>
                                            <div class="col-6">
                                                <span class="dot yellow"></span>{{recommendedFoods.fat[2]}}<br />
                                                <span class="dot yellow"></span>{{recommendedFoods.fat[3]}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="row">
                        <div class="col-12 col-md-6 offset-md-3 my-4">
                            <div class="row">
                                <h2 class="font24">Download {{userName | titlecase}}'s complete personalized report and eating guide. It&nbsp;includes:</h2>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-10 offset-1 col-md-6 offset-md-3">
                            <div class="row">
                                <div class="row">
                                    <div class="col-12 col-md-6">
                                        <div class="d-flex flex-row mb-3">
                                            <div>
                                                <span class="checkSpan mr-2">&#10003;</span>
                                            </div>
                                            <div class="flex-fill text-left">
                                                <b>How to get started on {{genderPronouns[genderBox]}} goals TODAY (and what to expect)</b>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12 col-md-6">
                                        <div class="d-flex flex-row mb-3">
                                            <div>
                                                <span class="checkSpan mr-2">&#10003;</span>
                                            </div>
                                            <div class="flex-fill text-left">
                                                <b>How to eat the right calories and macros at each meal</b>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12 col-md-6">
                                        <div class="d-flex flex-row mb-3">
                                            <div>
                                                <span class="checkSpan mr-2">&#10003;</span>
                                            </div>
                                            <div class="flex-fill text-left">
                                                <b>What foods to eat based on {{genderPronouns[genderBox]}} preferences</b>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12 col-md-6">
                                        <div class="d-flex flex-row mb-3">
                                            <div>
                                                <span class="checkSpan mr-2">&#10003;</span>
                                            </div>
                                            <div class="flex-fill text-left">
                                                <b>How to make adjustments and maximize {{genderPronouns[genderBox]}} results</b>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12 col-md-6">
                                        <div class="d-flex flex-row mb-3">
                                            <div>
                                                <span class="checkSpan mr-2">&#10003;</span>
                                            </div>
                                            <div class="flex-fill text-left">
                                                <b>Personalized portion tracker (this really works!)</b>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12 col-md-6">
                                        <div class="d-flex flex-row mb-3">
                                            <div>
                                                <span class="checkSpan mr-2">&#10003;</span>
                                            </div>
                                            <div class="flex-fill text-left">
                                                <b>And more!</b>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row my-4">
                        <div class="col-12 col-md-6 offset-md-3">
                            <img src="assets/images/proPdfPreview.png" class="w-100">
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-md-6 offset-md-3 mt-3">
                            <button class="my-4 greenButton" (click)="goForward('proEmail')">Download {{userName | titlecase}}'s complete guide</button>
                        </div>
                    </div>
                </div>


                <div class="content d-flex flex-column" id="proEmail">
                    <h2 *ngIf="calcPath=='selfWithProCopy'">Give your client a complete personalized report</h2>
                    <h2 *ngIf="calcPath=='pro'">Give {{userName | titlecase}} a complete personalized report</h2>
                    <div>We’ll instantly create a customized eating guide you can share.<span *ngIf="calcPath=='selfWithProCopy'">..for free!</span><br />
                        <span *ngIf="calcPath=='selfWithProCopy'">(Just enter your your name and email address below.)</span>
                        <span *ngIf="calcPath=='pro'">(Just enter your name and business to go on the cover page.)</span></div>

                    <div *ngIf="calcPath=='selfWithProCopy'" class="row">
                        <div class="col-10 offset-1 col-md-4 offset-md-4 mt-2">
                            <div class="text-left"><span class="fontBlue"><b>Client's First Name</b></span></div>
                            <div class="inputDiv flex-fill d-flex">
                                <input id="name" class="smallInput largeNumber flex-fill" type="text" [placeholder]="'Client\'s First Name'" (change)="capitalizeNames()" [(ngModel)]="userName" />
                            </div>                            
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-10 offset-1 col-md-4 offset-md-4 mt-2 mb-2">
                            <div class="text-left"><span class="fontBlue"><b>Add your name to the cover page</b></span></div>
                            <div class="inputDiv flex-fill d-flex">
                                <input class="smallInput largeNumber flex-fill form-input" type="text" [placeholder]="calcPath=='selfWithProCopy'?'Your First Name':'Your Full Name'" [(ngModel)]="coachName" [(formControl)]="coachFirstName"/>
                            </div>
                            <div id="name-error" class="formErrorBelow" *ngIf="coachFirstName.touched&&coachFirstName.invalid">Please enter your full name.</div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-10 offset-1 col-md-4 offset-md-4 mt-2 mb-2">
                            <div class="text-left"><span class="fontBlue"><b>Add your business name to the cover</b></span></div>
                            <div class="inputDiv flex-fill d-flex">
                                <input class="smallInput largeNumber flex-fill form-input" type="text" [placeholder]="'Business Name'" [(ngModel)]="businessName" [(formControl)]="companyName" />
                            </div>
                            <div id="name-error" class="formErrorBelow" *ngIf="companyName.touched&&companyName.invalid">Please enter your business name.</div>
                        </div>
                    </div>

                    <div *ngIf="calcPath=='selfWithProCopy'" class="row">
                        <div class="col-10 offset-1 col-md-4 offset-md-4 mt-2">
                                <div class="text-left"><span class="fontBlue"><b>Your Email</b></span></div>
                            <div class="inputDiv flex-fill d-flex">
                                <input id="email" class="smallInput largeNumber flex-fill" type="text" [placeholder]="'Your Email Address'" [(ngModel)]="userEmail" />
                            </div>                          

                        </div>
                    </div>

                    <div *ngIf="calcPath=='pro'" class="row">
                        <div class="col-10 offset-1 col-md-4 offset-md-4 mt-2 mb-2">
                            <div class="text-left"><span class="fontBlue"><b>Add your logo to the report (optional)</b></span>
                                <img src="assets/images/info.svg" (click)="showModal(contentData['proEmail'].modal)" class="gender infoButton"></div>
                            <div class="inputDiv flex-fill d-flex">
                                <input class="d-none smallInput flex-fill" id="logo-input" type="file" (change)="fileChanged($event)">
                                <label for="logo-input" class="greenButton">Choose File</label>
                                
                                <span>{{logoFileDisplay}}</span>
                            </div>
                            <div class="smallSubtext pt-1">Image must be a jpeg, png, or svg</div>
                            <canvas id="logoCanvas"></canvas>
                        </div>
                    </div>                    

                    <div class="mt-auto mb-3">
                        <button [disabled]="(businessName && coachName) ? false : true" (click)="processLogo()" class="greenButton">Download it now!</button>
                    </div>
                </div>

                <!-- SELF PATH -->

                <div class="content d-flex flex-column" id="pathway">
                    <div>
                        <span class="lineThingy"></span>
                        <h1 class="pathwayTitle">
                            <b>Is this for yourself, or for a client?</b>
                        </h1>
                    </div>
                    <div class="mt-auto">
                        <button (click)="initiateSelfPathway()" class="greenButton">Myself</button>
                        <button (click)="initiateProPathway()" class="greenButton">Client</button>
                    </div>
                </div>


                <div class="content d-flex flex-column" id="weight">
                    <div class="spacer"></div>
                    <div>
                        <div class="inputDiv d-inline-flex">
                            <input class="normalInput largeNumber" type="number" [(ngModel)]="initialWeightField" (change)="changeInitialWeightField()" [min]="(weightUnitsRadioGroup == 'lbs') ? 50 : 23" [max]="(weightUnitsRadioGroup == 'lbs') ? 500 : 227"  />

                            <!--div class="btn-group-vertical mr-1">
                                <button tabindex="-1" type="button" (click)="increment('initialWeightField')">&#x25B2;</button>
                                <button tabindex="-1" type="button" (click)="decrement('initialWeightField')">&#x25BC;</button>
                            </div-->
                            <div class="btn-group btn-group-toggle" ngbRadioGroup name="weightRadio" [(ngModel)]="weightUnitsRadioGroup" (change)="changeWeightUnits()">
                                <label ngbButtonLabel class="btn responsive">
                                    <input ngbButton type="radio" value="lbs">lbs
                                </label>
                                <label ngbButtonLabel class="btn responsive">
                                    <input ngbButton type="radio" value="kg">kg
                                </label>
                            </div>
                        </div>
                        <div *ngIf="weightUnitsRadioGroup=='lbs'">
                          <div class="smallSubtext pt-1 text-center">Valid weight is 50-500 lbs</div>
                        </div>
                        <div *ngIf="weightUnitsRadioGroup=='kg'">
                          <div class="smallSubtext pt-1 text-center">Valid weight is 23-227 kg</div>
                        </div>
                    </div>
                    <div class="mt-auto">
                        <button [attr.disabled]="initialWeightField && ((weightUnitsRadioGroup == 'lbs' && initialWeightField >= 50 && initialWeightField <= 500) || (weightUnitsRadioGroup == 'kg' && initialWeightField >= 23 && initialWeightField <= 227)) ? null : true" (click)="goForward()" class="greenButton mb-3">Next</button>
                    </div>
                </div>


                <div class="content d-flex flex-column" id="height">
                    <div class="my-2">
                        <div class="inputDiv d-inline-flex">
                            <div class="btn-group btn-group-toggle" ngbRadioGroup name="heightRadio" [(ngModel)]="heightUnitsGroup" (change)="changeHeightUnits()">
                                <label ngbButtonLabel class="btn">
                                    <input ngbButton type="radio" value="Inches">ft
                                </label>
                                <label ngbButtonLabel class="btn">
                                    <input ngbButton type="radio" value="Centimeters">cm
                                </label>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="heightUnitsGroup=='Centimeters'">
                        <div class="inputDiv d-inline-flex my-2">
                            <input class="normalInput largeNumber flex-fill" type="number" [(ngModel)]="heightField" (change)="changeHeightField()"  />
                            <!--div class="btn-group-vertical mr-1">
                                <button tabindex="-1" type="button" (click)="increment('heightField')">&#x25B2;</button>
                                <button tabindex="-1" type="button" (click)="decrement('heightField')">&#x25BC;</button>
                            </div-->
                            <span>cm</span>
                        </div>
                        <div class="smallSubtext pt-1 text-center">Valid height is 60-300cm</div>
                    </div>
                    <div *ngIf="heightUnitsGroup=='Inches'">
                        <div class="inputDiv d-inline-flex my-2">
                            <input class="normalInput smallNumber" type="number" [(ngModel)]="heightFt" (change)="changeHeightFeet()" min="2" max="9" />
                            <!--div class="btn-group-vertical mr-1">
                                <button tabindex="-1" type="button" (click)="increment('heightFt')">&#x25B2;</button>
                                <button tabindex="-1" type="button" (click)="decrement('heightFt')">&#x25BC;</button>
                            </div-->
                            <span>ft</span>
                        </div>
                    </div>
                    <div *ngIf="heightUnitsGroup=='Inches'">
                        <div class="inputDiv d-inline-flex my-2">
                            <input class="normalInput smallNumber" type="number" [(ngModel)]="heightIn" (change)="changeHeightFeet()" min="0" max="13"  />
                            <!--div class="btn-group-vertical mr-1">
                                <button tabindex="-1" type="button" (click)="increment('heightIn')">&#x25B2;</button>
                                <button tabindex="-1" type="button" (click)="decrement('heightIn')">&#x25BC;</button>
                            </div-->
                            <span>in</span>
                        </div>
                        <div class="smallSubtext pt-1 text-center">Valid height is 2'-9'11"</div>
                    </div>
                    <div class="mt-auto">
                        <button [attr.disabled]="((heightUnitsGroup == 'Centimeters' && heightField >= 60 && heightField <= 300) || (heightUnitsGroup == 'Inches' && heightFt && heightIn >= 0 && heightIn < 12 && heightFt >= 2 && heightFt <= 9)) ? null : true" (click)="goForward()" class="greenButton mb-3">Next</button>
                    </div>
                </div>


                <div class="content d-flex flex-column" id="sex">
                    <div class="row customRadios">
                        <div class="offset-2 col-4 col-md-3 offset-md-3 justify-content-center" [ngClass]="{'active': genderBox == 'Male'}">
                            <img src="assets/images/man.svg" id="male" class="sexImage" (click)="selfGenderChange('Male')">
                        </div>
                        <div class="col-4 col-md-3 justify-content-center" [ngClass]="{'active': genderBox == 'Female'}">
                            <img src="assets/images/woman.svg" id="female" class="sexImage" (click)="selfGenderChange('Female')">
                        </div>
                    </div>
                    <div>
                        <div class="row">
                            <div class="col-4 offset-2 col-md-3 offset-md-3 justify-content-center">
                                <button (click)="selfGenderChange('Male')" class="greenButton">Male</button>
                            </div>
                            <div class="col-4 col-md-3 justify-content-center">
                                <button (click)="selfGenderChange('Female')" class="greenButton">Female</button>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="content d-flex flex-column" id="age">
                    <div class="row mt-auto justify-content-center">
                        <div class="col-12">
                            <div class="d-inline-flex inputDiv justify-content-center">
                                <input class="hugeInput" type="number" [(ngModel)]="ageField" (change)="changeAgeField()" min="18" max="120"  />
                            </div>
                            <div class="smallSubtext pt-1 text-center">Valid age is 18-120</div>
                        </div>

                    </div>
                    <div class="mt-auto">
                        <button [attr.disabled]="ageField && ageField >= 18 && ageField <= 120 ? null : true" (click)="goForward()" class="greenButton mb-3">Next</button>
                    </div>
                </div>

                <div class="content d-flex flex-column" id="exercise">
                    <app-custom-options [optionCollection]="contentData.exercise.options" [(comparitor)]="ExerciseLevel" [onChange]="calculatePAL" [path]="calcPath"></app-custom-options>

                    <div class="mt-auto">
                        <button [attr.disabled]="ExerciseLevel ? null : true"  (click)="goForward()" class="greenButton mb-3">Next</button>
                    </div>
                </div>
                
                <div class="content d-flex flex-column" id="activity">
                    <app-custom-options [optionCollection]="contentData.activity.options" [(comparitor)]="WorkActivityLevel" [onChange]="calculatePAL" [path]="calcPath"></app-custom-options>

                    <div class="mt-auto">
                        <button [attr.disabled]="WorkActivityLevel ? null : true" (click)="goForward()" class="greenButton mb-3">Next</button>
                    </div>
                </div>


                <div class="content d-flex flex-column" id="diet">
                    <app-custom-options [optionCollection]="contentData.diet.options" [(comparitor)]="dietaryPreference" [info]="true" [onChange]="setRecommendedFoods" [path]="calcPath"></app-custom-options>

                    <div class="mt-auto">
                        <button [attr.disabled]="dietaryPreference ? null : true" (click)="updateMacroOptions()" class="greenButton mb-3">Next</button>
                    </div>
                </div>


                <div class="content d-flex flex-column" id="macroSwitch">
                    <div class="row">
                        <div class="col-8 offset-2 col-md-4 offset-md-4 justify-content-center">
                            <!--img src="assets/images/doughnut.svg" class="sexImage"-->
                            <canvas baseChart
                                [data]="dietPreferenceDoughnutValues"
                                [chartType]="doughnutChartType"
                                [legend]=false
                                [options]="{aspectRatio:1,tooltips:{enabled:false}}"
                                [colors]="doughnutColors">
                            </canvas>
                        </div>
                    </div>
                    <div class="row">
                            <div class="col-12 justify-content-center">
                                <div><span class="bubble blue"></span> <span *ngIf="showTilda" class="tilda">~</span>{{dietPreferenceDoughnutValues[0]}}% protein
                                    <span class="bubble orange"></span> <span *ngIf="showTilda" class="tilda">~</span>{{dietPreferenceDoughnutValues[1]}}% carb
                                    <span class="bubble yellow"></span> <span *ngIf="showTilda" class="tilda">~</span>{{dietPreferenceDoughnutValues[2]}}% fat </div>
                            </div>
                        </div>
                    <div>
                        <div class="row">
                            <div class="col-12 col-md-6 offset-md-3 justify-content-center">
                                <button (click)="setMealStandard()" class="greenButton mb-3">Use standard</button>
                                <button (click)="goForward('macros')" class="greenButton mb-3">Customize</button>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="content d-flex flex-column" id="macros">
                    <div class="row">
                        <div class="col-12 my-2">
                            <div class="inputDiv d-inline-flex justify-content-center rounded">
                                <div class="btn-group btn-group-toggle" ngbRadioGroup name="macroAdjustTypeRadio" [(ngModel)]="customMacroAdjustType">
                                    <label ngbButtonLabel class="btn">
                                        <input ngbButton type="radio" value="recommendations">Recommendations
                                    </label>
                                    <label ngbButtonLabel class="btn">
                                        <input ngbButton type="radio" value="own" (click)="enableCustomMacroPercentages()">Enter My Own
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <app-custom-options *ngIf="customMacroAdjustType === 'recommendations'" [optionCollection]="filteredMacroOptions" [(comparitor)]="macroPreference" [path]="calcPath"></app-custom-options>

                    <div class="d-flex flex-column " *ngIf="customMacroAdjustType === 'own'">
                        <div class="row">
                            <div class="col-10 offset-1">
                                <div class="slider">
                                    <span class="fontBlue">Protein</span>
                                    <mat-slider thumbLabel [(ngModel)]="customProteinPercent" class="alternate-theme" (input)="sliderInput($event, 'protein')" (change)="sliderChange($event,'protein')" appSliderLimits [macro]="'protein'" [map]="dietMapping" [path]="calcPath" [diet]="dietaryPreference" [displayWith]="formatSliderLabel"></mat-slider>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-10 offset-1">
                                <div class="slider">
                                    <span class="fontOrange">Carb</span>
                                    <mat-slider thumbLabel  [(ngModel)]="customCarbPercent" class="alternate-theme" (input)="sliderInput($event, 'carbs')" (change)="sliderChange($event,'carbs')" appSliderLimits [macro]="'carbs'" [map]="dietMapping" [path]="calcPath" [diet]="dietaryPreference" [displayWith]="formatSliderLabel"></mat-slider>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-10 offset-1">
                                <div class="slider">
                                    <span class="fontYellow">Fat</span>
                                    <mat-slider thumbLabel  [(ngModel)]="customFatPercent" class="alternate-theme" (input)="sliderInput($event, 'fat')" (change)="sliderChange($event,'fat')" appSliderLimits [macro]="'fat'" [map]="dietMapping" [path]="calcPath" [diet]="dietaryPreference" [displayWith]="formatSliderLabel"></mat-slider>
                                </div>
                            </div>
                        </div>
                        <!--div class="row">
                            <div class="col-12">
                                <div class="text-center">
                                        <span class="checkSpan" *ngIf="totalCustomPercent == 100">&#10003;</span> Total: <b>{{totalCustomPercent || 0}}%</b>
                                        <br /> <i>*Macronutrient percentages must add up to 100%.</i>
                                </div>
                            </div>
                        </div-->

                        <div class="row">
                                <div class="col-12">
                                    <div class="text-center">
                                        The adjustable macronutrient ranges are based on your chosen eating style: <b>{{dietaryPreference}}</b>
                                    </div>
                                </div>
                            </div>
                    </div>

                    <div class="mt-auto"><!--[attr.disabled]="isSlideComplete('macros') ? null : true"-->
                        <button [attr.disabled]="((customMacroAdjustType=='recommendations' && macroPreference) || (customMacroAdjustType=='own' && customProteinPercent && customCarbPercent && customFatPercent && (totalCustomPercent == 100))) ? null : true" (click)="goForward()" class="greenButton mb-3">Next</button>
                    </div>
                </div>


                <div class="content d-flex flex-column" id="meals">
                    <div class="mt-auto">
                        <div class="d-inline-flex inputDiv">
                            <input class="hugeInput" type="number" [(ngModel)]="mealsPerDay" [min]="1" [max]="8" (change)="changeMeals()" />
                        </div>
                        <div class="smallSubtext pt-1 text-center">Valid selection is 1 to 8 meals.</div>
                    </div>
                    <div class="mt-auto">
                        <button [attr.disabled]="mealsPerDay && mealsPerDay > 0 && mealsPerDay <= 8 ? null : true"  (click)="goForward()" class="greenButton mb-3">Next</button>
                    </div>
                </div>


                <div class="content d-flex flex-column" id="goal">

                    <app-custom-options [optionCollection]="contentData.goal.options" [(comparitor)]="goalPreference" [info]="true" [path]="calcPath"></app-custom-options>

                    <div class="mt-auto mb-2">
                        <button [attr.disabled]="goalPreference ? null : true" (click)="goForward()" class="greenButton mb-3">Next</button>
                    </div>
                </div>


                <div class="content d-flex flex-column" id="targets">
                    <div>
                        <div class="row">
                            <div class="col-12 col-md-6 offset-md-3 px-4">
                                <div class="inputDiv flex-fill d-flex">
                                    <input class="normalInput largeNumber flex-fill" type="number" [(ngModel)]="goalWeight" (change)="changeWeightUnits()" [min]="(weightUnitsRadioGroup == 'lbs') ? 50 : 23" [max]="(weightUnitsRadioGroup == 'lbs') ? 500 : 227" />

                                    <!--div class="btn-group-vertical mr-1">
                                        <button tabindex="-1" type="button" (click)="increment('goalWeight')">&#x25B2;</button>
                                        <button tabindex="-1" type="button" (click)="decrement('goalWeight')">&#x25BC;</button>
                                    </div-->
                                    <div class="btn-group btn-group-toggle" ngbRadioGroup name="weightRadio" [(ngModel)]="weightUnitsRadioGroup" (change)="changeWeightUnits()">
                                        <label ngbButtonLabel class="btn responsive">
                                            <input ngbButton type="radio" value="lbs">lbs
                                        </label>
                                        <label ngbButtonLabel class="btn responsive">
                                            <input ngbButton type="radio" value="kg">kg
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="weightUnitsRadioGroup=='lbs'">
                          <div class="smallSubtext pt-1 text-center">Valid weight is 50-500 lbs</div>
                        </div>
                        <div *ngIf="weightUnitsRadioGroup=='kg'">
                          <div class="smallSubtext pt-1 text-center">Valid weight is 23-227 kg</div>
                        </div>


                        <div class="spacer"></div>

                        <div>
                            <h2>By When?</h2>
                        </div>

                        <div class="spacer"></div>

                        <div class="row">
                            <div class="col-12 col-md-6 offset-md-3 px-4">
                                <div class="inputDiv flex-fill d-flex">
                                    <mat-form-field class="example-full-width">
                                        <input matInput [matDatepicker]="picker" [min]="minDate" [(ngModel)]="targetDate" class="normalInput d-flex flex-fill">
                                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                        <mat-datepicker touchUi #picker [startAt]="targetDate" ></mat-datepicker>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>


                    </div>
                    <div class="mt-auto"><!--[attr.disabled]="isSlideComplete('targets') ? null : true"-->
                        <!--><button [attr.disabled]="(goalWeight && targetDate) ? null : true" (click)="goForward()" class="greenButton mb-3">Next</button>-->
                        <button [attr.disabled]="goalWeight && ((weightUnitsRadioGroup == 'lbs' && goalWeight >= 50 && goalWeight <= 500) || (weightUnitsRadioGroup == 'kg' && goalWeight >= 23 && goalWeight <= 227)) && targetDate ? null : true" (click)="goForward()" class="greenButton mb-3">Next</button>
                    </div>
                </div>


                <div class="content d-flex flex-column" id="finishUp">
                    <div class="d-inline-flex justify-content-center">
                        <mat-progress-spinner [mode]="'indeterminate'" class="alternate-theme"></mat-progress-spinner>
                    </div>

                    <div>We're creating a personalized eating plan customized for your body, activity levels, eating preferences, and goals.</div>
                    <div class="mt-auto">
                        <button (click)="runCalculations()" class="greenButton mb-3">Next</button>
                    </div>
                </div>


                <div class="content d-flex flex-column" id="results">
                    <div class="row">
                        <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3 mb-3">
                            <div class="mx-3">
                                <h2 class="mt-4 mb-3"><span *ngIf="calcPath == 'self'">Your</span><span *ngIf="calcPath == 'selfWithProCopy'">Your Client's</span> Results</h2>

                                <div class="font18">
                                    We’ve created a personalized eating guide for your <span *ngIf="calcPath == 'selfWithProCopy'">client's</span> body, activity levels, eating preferences, and goals.
                                </div>
                                <div class="smallLabel mt-2">
                                    (Brief summary below)
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3 col-xl-4 offset-xl-4 mb-3">
                            <div class="mx-3">
                                <button class="mt-4 greenButton fullWidth" (click)="goForward()">Get <span *ngIf="calcPath == 'self'">your</span><span *ngIf="calcPath == 'selfWithProCopy'">the</span> complete guide FREE</button>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-md-8 offset-md-2 my-4">
                            <div class="horizontalLine"></div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-md-6 offset-md-3 text-left">
                            <div class="mb-2">
                                <h2 class="text-left">Brief Summary
                                    <!--button class="darkGrayButton float-right" (click)="startSelfEdit()">
                                        <fa-icon [icon]="faPencilAlt"></fa-icon>
                                    </button-->
                                </h2>
                            </div>
                            <div class="font18 fontGray">
                                <div><span class='foat-left'><fa-icon [icon]="faUser"></fa-icon>Age</span><span class="float-right"><b>{{ageField}}</b></span></div>
                            </div>

                            <div class="horizontalLine my-2"></div>

                            <div class="font18 fontGray">
                                <div><span class='foat-left'><fa-icon [icon]="faWeight"></fa-icon>Current Weight</span><span class="float-right"><b>{{initialWeightField | number:'1.0-0'}} {{weightUnitsRadioGroup}}</b></span></div>
                            </div>

                            <div class="horizontalLine my-2"></div>

                            <div class="font18 fontGray">
                                <div><span class='foat-left'><fa-icon [icon]="faUtensils"></fa-icon>Eating Style</span><span class="float-right"><b>{{dietaryPreference}}</b></span></div>
                            </div>

                            <div class="horizontalLine my-2"></div>

                            <div class="font18 fontGray">
                                <div>
                                    <span class='foat-left'><fa-icon [icon]="faChartPie"></fa-icon>Macro Percentages</span>
                                    <span class="float-right text-left">
                                        <b class="fontBlue"><span *ngIf="customMacroAdjustType!='own'&&macroPreference!='Very low-carb'&&macroPreference!=='Very low-fat'" class="tilda">~</span>{{finalProteinPercentage}}% Protein</b><br class="d-md-none"/>
                                        <b class="fontOrange ml-md-3"><span *ngIf="customMacroAdjustType!='own'&&macroPreference!='Very low-carb'&&macroPreference!=='Very low-fat'" class="tilda">~</span>{{finalCarbsPercentage}}% Carbs</b><br class="d-md-none"/>
                                        <b class="fontYellow ml-md-3"><span *ngIf="customMacroAdjustType!='own'&&macroPreference!='Very low-carb'&&macroPreference!=='Very low-fat'" class="tilda">~</span>{{finalFatPercentage}}% Fat</b><br class="d-md-none"/>
                                    </span>
                                </div>
                                <div class="clear"></div>
                            </div>

                            <div class="horizontalLine mt-2 mb-5"></div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-md-6 offset-md-3">
                            <div *ngIf="goalPreference=='Lose Weight'||goalPreference=='Build Muscle'">
                                <div class="font16">To maintain <span *ngIf="calcPath == 'self'">your</span><span *ngIf="calcPath == 'selfWithProCopy'">their</span> current weight requires about <b>{{maintCalsField | number:'1.0-0'}} Calories per day.</b></div>
                                <br />
                                <div class="font18">To reach <span *ngIf="calcPath == 'self'">your</span><span *ngIf="calcPath == 'selfWithProCopy'">their</span> goal of <b>{{goalWeight | number:'1.0-0'}} {{weightUnitsRadioGroup}}</b> in <b>{{goalTime}} days</b> at <span *ngIf="calcPath == 'self'">your</span><span *ngIf="calcPath == 'selfWithProCopy'">their</span> current body weight and activity level, requires about:</div>
                                <h2 class="mt-2 calsPerDay">{{goalCalsField | number:'1.0-0'}} Calories per day.</h2>
                            </div>

                            <div *ngIf="goalPreference!='Lose Weight'&&goalPreference!='Build Muscle'">
                                <div *ngIf="goalPreference=='Body Recomposition'" class="font18">At <span *ngIf="calcPath == 'self'">your</span><span *ngIf="calcPath == 'selfWithProCopy'">their</span> current body weight and activity level, <span *ngIf="calcPath == 'self'">your</span><span *ngIf="calcPath == 'selfWithProCopy'">their</span> goal of <b>{{goalPreference}}</b> requires about:</div>

                                <div *ngIf="goalPreference=='Improve Health'" class="font18">At <span *ngIf="calcPath == 'self'">your</span><span *ngIf="calcPath == 'selfWithProCopy'">their</span> current body weight and activity level, <span *ngIf="calcPath == 'self'">your</span><span *ngIf="calcPath == 'selfWithProCopy'">their</span> goal to <b>{{goalPreference}}</b> requires about:</div>

                                <div *ngIf="goalPreference=='Athletic Performance'" class="font18">At <span *ngIf="calcPath == 'self'">your</span><span *ngIf="calcPath == 'selfWithProCopy'">their</span> current body weight and activity level, <span *ngIf="calcPath == 'self'">your</span><span *ngIf="calcPath == 'selfWithProCopy'">their</span> goal of <b>{{goalPreference}}</b> requires about:</div>

                                <h2 class="mt-2 calsPerDay">{{maintCalsField | number:'1.0-0'}} Calories per day.</h2>
                            </div>

                            <div class="font18 fontGray text-center halfOpacity mt-3 mb-4"><b>HERE'S HOW THAT BREAKS DOWN:</b></div>
                        </div>
                    </div>

                    <div class="row">
                        <!-- PALMS PROTEIN -->
                        <div class="col-12 col-md-6 offset-md-3 border-top">
                            <div class="row text-left">
                                <div class="col-3">
                                    <div class="d-flex h-100 justify-content-center align-items-center handCell">
                                        <img class="my-auto" src="assets/images/palm.svg">
                                    </div>
                                </div>

                                <div class="col-9 copyCol">
                                    <div class="font18">
                                        <b>{{totalPalms}} palm-sized portions (or {{totalProtein}} g) of <span class="fontBlue">protein</span> per day</b>
                                    </div>
                                    <div class="font14">
                                        That's <b>{{perMealPalms}} total palms</b> or <b>{{perMealProtein}} g</b> per meal.
                                    </div>
                                    <div class="font14">
                                        <span class="fontBlue">FOR EXAMPLE</span><br />
                                        <div class="row forExample">
                                            <div class="col-5">
                                                <span *ngIf="recommendedFoods.protein[0]" class="dot blue"></span>{{recommendedFoods.protein[0]}}<br />
                                                <span *ngIf="recommendedFoods.protein[1]" class="dot blue"></span>{{recommendedFoods.protein[1]}}
                                            </div>
                                            <div class="col-6">
                                                <span *ngIf="recommendedFoods.protein[2]" class="dot blue"></span>{{recommendedFoods.protein[2]}}<br />
                                                <span *ngIf="recommendedFoods.protein[3]" class="dot blue"></span>{{recommendedFoods.protein[3]}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- FISTS VEGGIES -->
                        <div class="col-12 col-md-6 offset-md-3 border-top">
                            <div class="row text-left">
                                <div class="col-3">
                                    <div class="d-flex h-100 justify-content-center align-items-center handCell">
                                        <img class="my-auto" src="assets/images/fist.svg">
                                    </div>
                                </div>

                                <div class="col-9 copyCol">
                                    <div class="font18">
                                        <b>{{totalFists}} fist-sized portions of <span class="fontGreen">veggies</span> per day</b>
                                    </div>
                                    <div class="font14">
                                        That's <b>{{perMealFists}} total fists</b> per meal.
                                    </div>
                                    <div class="font14">
                                        <span class="fontGreen">FOR EXAMPLE</span><br />
                                        <div class="row forExample">
                                            <div class="col-5">
                                                <span class="dot green"></span>{{recommendedFoods.veggies[0]}}<br />
                                                <span class="dot green"></span>{{recommendedFoods.veggies[1]}}
                                            </div>
                                            <div class="col-6">
                                                <span class="dot green"></span>{{recommendedFoods.veggies[2]}}<br />
                                                <span class="dot green"></span>{{recommendedFoods.veggies[3]}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="row">
                        <!-- HANDFULS CARBS -->
                        <div class="col-12 col-md-6 offset-md-3 border-top">
                            <div class="row text-left">
                                <div class="col-3">
                                    <div class="d-flex h-100 justify-content-center align-items-center handCell">
                                        <img class="my-auto" src="assets/images/cupped.svg">
                                    </div>
                                </div>

                                <div class="col-9 copyCol">
                                    <div class="font18">
                                        <b>{{totalHandfuls}} cupped handfuls (or {{totalCarbs}} g) of <span class="fontOrange">carbs</span> per day</b>
                                    </div>
                                    <div class="font14">
                                        That's <b>{{perMealHandfuls}} total handfuls</b> or <b>{{perMealCarbs}} g</b> per meal.
                                    </div>
                                    <div class="font14">
                                        <span class="fontOrange">FOR EXAMPLE</span><br />
                                        <div class="row forExample">
                                            <div class="col-5">
                                                <span *ngIf="recommendedFoods.carbs[0]" class="dot orange"></span>{{recommendedFoods.carbs[0]}}<br />
                                                <span *ngIf="recommendedFoods.carbs[1]" class="dot orange"></span>{{recommendedFoods.carbs[1]}}
                                            </div>
                                            <div class="col-6">
                                                <span *ngIf="recommendedFoods.carbs[2]" class="dot orange"></span>{{recommendedFoods.carbs[2]}}<br />
                                                <span *ngIf="recommendedFoods.carbs[3]" class="dot orange"></span>{{recommendedFoods.carbs[3]}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- THUMBS FATS -->
                        <div class="col-12 col-md-6 offset-md-3 border-top border-bottom">
                            <div class="row text-left">
                                <div class="col-3">
                                    <div class="d-flex h-100 justify-content-center align-items-center handCell">
                                        <img class="my-auto" src="assets/images/thumb.svg">
                                    </div>
                                </div>

                                <div class="col-9 copyCol">
                                    <div class="font18">
                                        <b>{{totalThumbs}} thumb-sized portions (or {{totalFats}} g) of <span class="fontYellow">healthy fats</span> per day</b>
                                    </div>
                                    <div class="font14">
                                        That's <b>{{perMealThumbs}} total thumbs</b> or <b>{{perMealFats}} g</b> per meal.
                                    </div>
                                    <div class="font14">
                                        <span class="fontYellow">FOR EXAMPLE</span><br />
                                        <div class="row forExample">
                                            <div class="col-5">
                                                <span class="dot yellow"></span>{{recommendedFoods.fat[0]}}<br />
                                                <span class="dot yellow"></span>{{recommendedFoods.fat[1]}}
                                            </div>
                                            <div class="col-6">
                                                <span class="dot yellow"></span>{{recommendedFoods.fat[2]}}<br />
                                                <span class="dot yellow"></span>{{recommendedFoods.fat[3]}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="row">
                        <div class="col-12 col-md-6 offset-md-3 my-4">
                            <div class="row">
                                <h2 class="font24 px-2">Get your <span *ngIf="calcPath == 'selfWithProCopy'">client's</span> FREE personalized report and eating guide. It&nbsp;includes:</h2>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-10 offset-1 col-md-6 offset-md-3">
                            <div class="row">
                                <div class="row">
                                    <div class="col-12 col-md-6">
                                        <div class="d-flex flex-row mb-3">
                                            <div>
                                                <span class="checkSpan mr-2">&#10003;</span>
                                            </div>
                                            <div class="flex-fill text-left">
                                                <b>How <span *ngIf="calcPath == 'self'">to</span><span *ngIf="calcPath == 'selfWithProCopy'">they can</span> get started <span *ngIf="calcPath == 'self'">on your goals</span> TODAY (and what to expect)</b>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12 col-md-6">
                                        <div class="d-flex flex-row mb-3">
                                            <div>
                                                <span class="checkSpan mr-2">&#10003;</span>
                                            </div>
                                            <div class="flex-fill text-left">
                                                <b>How to eat the right calories and macros at each meal</b>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12 col-md-6">
                                        <div class="d-flex flex-row mb-3">
                                            <div>
                                                <span class="checkSpan mr-2">&#10003;</span>
                                            </div>
                                            <div class="flex-fill text-left">
                                                <b>What foods to eat based on <span *ngIf="calcPath == 'self'">your</span><span *ngIf="calcPath == 'selfWithProCopy'">their</span> preferences</b>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12 col-md-6">
                                        <div class="d-flex flex-row mb-3">
                                            <div>
                                                <span class="checkSpan mr-2">&#10003;</span>
                                            </div>
                                            <div class="flex-fill text-left">
                                                <b>How to make adjustments and maximize <span *ngIf="calcPath == 'self'">your</span><span *ngIf="calcPath == 'selfWithProCopy'">their</span> results</b>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12 col-md-6">
                                        <div class="d-flex flex-row mb-3">
                                            <div>
                                                <span class="checkSpan mr-2">&#10003;</span>
                                            </div>
                                            <div class="flex-fill text-left">
                                                <b>Personalized portion tracker (this really works!)</b>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12 col-md-6">
                                        <div class="d-flex flex-row mb-3">
                                            <div>
                                                <span class="checkSpan mr-2">&#10003;</span>
                                            </div>
                                            <div class="flex-fill text-left">
                                                <b>And more!</b>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="calcPath=='self'" class="row my-4">
                        <div class="col-12 col-md-6 offset-md-3">
                            <img src="assets/images/pdfPreview.png" class="w-100">
                        </div>
                    </div>

                    <div *ngIf="calcPath=='selfWithProCopy'" class="row my-4">
                            <div class="col-12 col-md-6 offset-md-3">
                                <img src="assets/images/proPdfPreview.png" class="w-100">
                            </div>
                        </div>

                    <div class="row">
                        <div class="col-12 col-md-4 offset-md-4 mt-3">
                            <button class="my-4 greenButton fullWidth" (click)="goForward()">Get <span *ngIf="calcPath == 'self'">your</span><span *ngIf="calcPath == 'selfWithProCopy'">the</span> complete guide FREE</button>
                        </div>
                    </div>
                </div>


                <div class="content d-flex flex-column" id="email">
                    <div>We'll instantly turn your results into a customized how-to eating guide… for free!<br />(Just enter your name and email address below.)</div>

                    <div class="row">
                        <div class="col-10 offset-1 col-md-4 offset-md-4 my-4">
                            <div class="inputDiv flex-fill d-flex">
                                <input id="name" class="smallInput largeNumber flex-fill form-input" type="text" [placeholder]="'First Name'" (change)="capitalizeNames()" [(ngModel)]="userName" [(formControl)]="firstName" />
                            </div>
                            <div id="name-error" class="formErrorBelow" *ngIf="firstName.touched&&firstName.invalid">Please enter your first name.</div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-10 offset-1 col-md-4 offset-md-4 mb-2">
                            <div class="inputDiv flex-fill d-flex">
                                <input id="email" class="smallInput largeNumber flex-fill form-input" type="text" [placeholder]="'Email Address'" [(ngModel)]="userEmail" [(formControl)]="email" />
                            </div>
                            <div id="email-error" class="formErrorBelow" *ngIf="email.touched&&email.invalid">Please enter a valid email address.</div>

                        </div>
                    </div>

                    <div class="row">
                        <div class="col-10 offset-1 col-md-4 offset-md-4">
                            <div class="pn-form--signup__subtext">By signing up, you'll also get exclusive updates,<br />content, and offers from Precision Nutrition.<br>Unsubscribe anytime. <a href="/contact" target="_blank">Contact Us</a>. <a href="/privacy-policy" target="_blank">Privacy Policy</a>.</div>
                        </div>
                    </div>

                    <div class="mt-auto mb-3">
                        <button [disabled]="(userEmail && userName && email.valid) ? false : true" (click)="processCaptcha()" class="greenButton">Download it now!</button>
                    </div>
                </div>


                <div class="content d-flex flex-column" id="confirm">
                    <div class="my-auto">
                        <img *ngIf="pdfGenerationDone" class="spinnerCheck" src="assets/images/largeCheck2.svg">
                        <div *ngIf="!pdfGenerationDone" class="mx-auto my-auto spinnerCheck">
                            <mat-progress-spinner
                                class="my-auto"
                                mode="indeterminate"
                                diameter=150>
                            </mat-progress-spinner>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-md-6 offset-md-3">
                            <div class="font18 confirmCopy">
                                <div *ngIf="calcPath == 'self'">After you read your report, make sure to check your email to learn about the special <b>Precision Nutrition Calculator Professional Edition</b>. (Not available to the general public.)</div>
                                <div *ngIf="calcPath == 'selfWithProCopy'">After you send them their report, make sure to check your email to learn about the special <b>Precision Nutrition Calculator Professional Edition</b>. (Not available to the general public.)</div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="clear"></div>
        </div>
    </div>
</div>
